import { KolumnaDoRaportu } from './kolumnaDoRaportu';
import { RodzajRaportu } from './rodzajRaportu';

export class ZapiszSzerokosciKolumnModel {
  idProjektu: string;
  rodzajRaportu: RodzajRaportu;
  kolumny: Array<KolumnaDoRaportu> = new Array();
}
